function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import clsx from "clsx";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
function useParallax(value, distance) {
    var reduceMotion = useReducedMotion();
    var position = useTransform(value, [
        0,
        1
    ], [
        -distance,
        distance
    ]);
    if (reduceMotion) {
        return 0;
    }
    return position;
}
function Triangle() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "417",
        height: "391",
        viewBox: "0 0 417 391",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M208.5 60L370.014 363H46.9863L208.5 60Z",
        stroke: "#951B81",
        strokeWidth: "56"
    }));
}
function Diamond() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "460",
        height: "305",
        viewBox: "0 0 460 305",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M421.21 152.18C357.34 109.85 293.48 67.5202 229.61 25.2002C165.74 67.5302 101.88 109.85 38.01 152.18C101.88 194.51 165.74 236.83 229.61 279.16C293.48 236.83 357.34 194.5 421.21 152.18Z",
        stroke: "#00A19A",
        strokeWidth: "42"
    }));
}
function A() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "628",
        height: "652",
        viewBox: "0 0 628 652",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M86.22 651.77C62.32 651.77 40.76 635.27 35.31 610.96C34.34 606.64 11.49 503.85 3.10001 385.42C-9.11999 212.96 14.71 100.75 75.97 42.3699C105.75 13.9999 159.19 -14.8701 244.65 8.64995C497.86 78.3899 645.36 407.39 625.81 552.09C615.88 625.58 567.51 651.76 525.56 651.76C446.05 651.76 414.2 587.03 390.94 539.77C377.8 513.08 365.4 487.87 347.55 472.92C285.51 420.97 204.08 435.69 203.27 435.85C175.01 441.62 147.59 423.38 141.8 395.11C136.02 366.85 154.42 339.21 182.68 333.43C187.96 332.35 313.22 307.94 414.61 392.82C449.39 421.94 468.13 460.04 484.67 493.65C503.1 531.1 512.09 551.28 520.76 546.64C535.73 538.63 525.92 483.74 498.96 410.64C453.27 286.76 348.34 145.57 216.91 109.37C170.52 96.5999 154.2 112.13 148.05 117.98C82.12 180.77 102.04 430.7 137.25 588.12C143.54 616.27 125.84 644.2 97.7 650.5C93.85 651.36 90.01 651.77 86.23 651.77",
        fill: "#FCEA0A"
    }));
}
function M() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "775",
        height: "630",
        viewBox: "0 0 775 630",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M153.14 629.2C137.42 629.2 121.92 621.9 112.02 608.17C110.63 606.25 77.72 560.39 48.17 501.92C4.21001 414.92 -9.47999 347.15 6.35001 294.71C17.89 256.45 44.72 228.42 83.94 213.65C198.04 170.67 242 257.61 262.4 299.75C282.07 340.37 291.67 346.76 307.1 343.55C331.7 338.45 343.37 264.6 353.98 212.23C370.92 128.5 388.46 41.9202 459.41 10.4002C505.31 -9.98983 560.4 -0.48983 627.82 39.4602C717.95 92.8902 767.13 160.31 773.99 239.89C786.73 387.7 641.11 513.95 634.9 519.25C613.63 537.43 581.66 534.92 563.48 513.65C545.31 492.37 547.82 460.4 569.09 442.23C600.32 415.3 680.06 327.85 673.03 248.35C669.05 203.32 636.46 162.35 576.16 126.62C524.95 96.2602 505.33 100.86 500.54 102.99C477.38 113.28 463.45 182.09 453.28 232.33C435.29 321.2 420.26 420.75 324.83 440.62C229.37 460.49 191.38 385.54 171.73 344.96C150.58 301.25 134.98 298.96 119.91 305.48C108.05 310.61 104.96 318.62 103.35 323.96C89.04 371.27 149.11 486.19 194.23 548.95C210.55 571.66 205.39 603.31 182.7 619.65C173.74 626.1 163.39 629.2 153.14 629.2Z",
        fill: "#FCEA0A"
    }));
}
function Z() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "576",
        height: "585",
        viewBox: "0 0 576 585",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M165.346 585C105.585 585 61.9767 571.323 33.5203 543.921C2.04786 513.593 -1.7762 481.22 0.559836 459.389C9.31996 377.655 116.241 311.588 240.043 235.09C299.116 198.584 397.381 137.793 408.645 110.351C414.262 96.6659 382.029 85.5548 270.924 119.815C202.419 140.934 140.306 170.502 139.69 170.798C114.937 182.637 85.273 172.189 73.4168 147.465C61.5607 122.741 72.0008 93.1008 96.7372 81.2463C99.2732 80.0313 159.714 51.2145 231.035 28.2651C338.605 -6.34701 413.366 -9.13676 459.606 19.696C490.559 38.9924 507.775 71.6221 508.087 111.566C508.663 185.866 413.19 244.858 292.316 319.55C242.027 350.621 190.034 382.747 151.73 412.899C107.625 447.607 102.857 458.862 105.089 469.109C107.457 479.989 144.218 506.471 318.796 461.739C417.63 436.416 506.671 400.389 507.567 400.029C532.975 389.709 561.976 401.908 572.32 427.303C582.664 452.707 570.44 481.675 545.015 492.003C541.143 493.578 448.782 530.947 343.485 557.926C273.108 575.959 213.891 584.984 165.346 584.984",
        fill: "#FCEA0A"
    }));
}
function E() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "740",
        height: "740",
        viewBox: "0 0 740 740",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M350.54 740C249.267 740 155.228 717.708 91.3294 678.546C22.0056 635.77 -9.94377 573.111 2.71537 505.03C11.7576 458.638 42.5014 399.594 137.746 378.507C190.191 367.06 250.473 369.47 303.521 371.88C333.662 373.085 377.667 374.892 396.354 371.277C407.205 370.072 407.808 364.048 402.383 356.818C396.957 350.793 380.078 339.948 368.625 332.718C329.442 307.414 269.763 270.06 252.281 191.736C234.197 109.798 261.926 43.5241 327.03 14.6047C438.551 -34.7993 629.644 45.9341 728.506 184.506C748.399 212.221 741.768 250.78 714.039 270.06C686.309 289.942 647.729 283.314 628.439 255.6C553.087 150.164 409.013 104.376 377.064 126.668C371.036 130.885 361.994 141.127 369.831 165.227C378.27 191.134 399.971 206.798 434.935 228.488C463.267 246.562 494.613 266.445 512.698 300.786C534.399 342.358 533.194 393.57 497.025 443.576C456.636 498.402 382.49 498.402 298.698 494.787C252.884 492.98 201.042 491.173 164.27 498.403C132.321 505.03 127.498 515.875 124.484 524.309C122.073 531.539 119.059 550.819 155.831 573.111C201.042 600.825 278.203 617.695 357.774 616.49C439.757 615.285 512.698 596.006 553.087 564.676C580.213 543.589 618.794 549.011 639.289 575.521C660.388 602.633 654.963 641.192 628.439 661.677C592.27 689.993 508.478 737.59 358.98 739.398C356.568 740 353.555 740 350.54 740Z",
        fill: "#FCEA0A"
    }));
}
function Shape(param) {
    var shape = param.shape;
    switch(shape){
        case "Diamond":
            return /*#__PURE__*/ React.createElement(Diamond, null);
        case "Triangle":
            return /*#__PURE__*/ React.createElement(Triangle, null);
        case "A":
            return /*#__PURE__*/ React.createElement(A, null);
        case "M":
            return /*#__PURE__*/ React.createElement(M, null);
        case "Z":
            return /*#__PURE__*/ React.createElement(Z, null);
        default:
            return /*#__PURE__*/ React.createElement(E, null);
    }
}
export function BlockBackgroundShapeStatic(param) {
    var position = param.position, shape = param.shape;
    return shape ? /*#__PURE__*/ React.createElement("div", {
        className: "relative container-content-wrapper -z-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("absolute", {
            "right-full -mr-32": position === "Left",
            "left-full -ml-32": position === "Right"
        })
    }, /*#__PURE__*/ React.createElement(Shape, {
        shape: shape
    }))) : null;
}
export function BlockBackgroundShapeAnimated(param) {
    var position = param.position, shape = param.shape;
    var ref = useRef(null);
    var scrollYProgress = useScroll({
        target: ref,
        offset: [
            "start end",
            "end start"
        ]
    }).scrollYProgress;
    var y = useParallax(scrollYProgress, 100);
    return shape ? /*#__PURE__*/ React.createElement("div", {
        className: "relative container-content-wrapper -z-10"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: clsx("absolute", {
            "right-full -mr-32": position === "Left",
            "left-full -ml-32": position === "Right"
        })
    }, /*#__PURE__*/ React.createElement(motion.div, {
        style: {
            y: y
        }
    }, /*#__PURE__*/ React.createElement(Shape, {
        shape: shape
    })))) : null;
}
export function BlockBackgroundShape(props) {
    var _useState = _slicedToArray(useState(true), 2), cms = _useState[0], setCMS = _useState[1];
    useEffect(function() {
        // @ts-ignore
        setCMS(!!window.CMS);
    }, []);
    return useReducedMotion() || cms ? /*#__PURE__*/ React.createElement(BlockBackgroundShapeStatic, _extends({}, props)) : /*#__PURE__*/ React.createElement(BlockBackgroundShapeAnimated, _extends({}, props));
}
